import React, { Fragment, useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { CommonModal, P, Spinner } from "../../AbstractElements";
import { Done } from "../../Constant";
import { driverColumns } from "../../Data/Driver/AssignDriver";
import { findPickupType } from "../../Services/Booking.service";
import { showAlert } from "../../Services/Shared.service";
import {
  getAssignDriverList,
  assignDriverToBooking,
} from "../../Services/Driver.service";
import Select from "react-select";
import { useForm, useController } from "react-hook-form";
import DataTable from "react-data-table-component";
import CustomSelect from "../../CommonElements/CustomSelect";
import { getAssignDriverListForVendorAssigned } from "../../Services/Ventor.service";

const DriverTypeList = [
  {
    value: "Active",
    label: "Active",
  },
  {
    value: "Inactive",
    label: "Inactive",
  },
  {
    value: "OnTrip",
    label: "OnTrip",
  },
  {
    value: "Assigned",
    label: "Assigned",
  }
];

const AssignDriver = (props) => {

  console.log("PROPS VALUE FOR ASSIGN DRIVER IS ::: >>>>> ", props)

  const { control, reset, register, setValue } = useForm();
  const [searchedData, setSearchedData] = useState(null);
  const driverTypeField = useController({
    name: "driverType",
    control,
  }).field;
  const [pickupType, setPickupType] = useState(null);
  const [bookingId, setBookingId] = useState(null);
  const [driverData, setDriverData] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState({});
  const [loader, setLoader] = useState(false)
  const [isSubmitting,setIsSubmitting] = useState(false)

  const onDriverSelected = (element) => {
    console.log(element, 'element');
    setSelectedDriver(element);
  };

  const assignDriver = () => {
    props.setShowApiLoader(true);
    setIsSubmitting(true)
    console.log(selectedDriver, "selectedDriverData");
    let isOnTripAssign = driverTypeField.value == "OnTrip" ? true : false;
    let isAssignLogoutDriver =
      driverTypeField.value == "Inactive" ? true : false;
    let isQueueAssigned= driverTypeField.value == "Assigned" ? true : false;
    let obj = {
      aggregatorId : props.assignDriverBookingObj.aggregatorId,
      bookingId: bookingId.toString(),
      carCurrentStatusId: selectedDriver.id.toString(),
      carTypeId: selectedDriver.carTypeId.toString(),
      isOnTripAssign: isOnTripAssign,
      isAssignLogoutDriver: isAssignLogoutDriver,
      isQueueAssigned:isQueueAssigned,
      reAssign: props.assignDriverBookingObj.currentBookingStatusType == "Confirmed" || props.assignDriverBookingObj.currentBookingStatusType == "ReachedPickup" ? true : false,
      isNormalAssigned:driverTypeField.value == "Active" ? true : false
    };
    console.log(obj, "obj");
    assignDriverToBooking(obj)
      .then((assignDriverRes) => {
        props.setShowApiLoader(false);
        setIsSubmitting(false)
        props?.onSubmitData?.fetchBookingData().then((result) => {
          props.LargeModaltoggle();
          driverTypeField.onChange("")
        });
      })
      .catch((err) => {
        setIsSubmitting(false)
        props.setShowApiLoader(false);
        showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
      });
  };

  const fetchAssignDriverList = () => {
    const obj = {
      pickupType,
      bookingId,
      driverType: driverTypeField.value,
      vendorId: props?.assignDriverBookingObj?.aggregatorId ? props.assignDriverBookingObj.aggregatorId : null,
    };
    setLoader(true);
    setSelectedDriver({});
    setSearchedData(null);
    setValue("searchTable", null);
    console.log(">>>> PROPS VALUE IS ::: ", props)
    if(props.assignDriverBookingObj.aggregatorId !== null){
      getAssignDriverListForVendorAssigned(obj)
      .then((result) => {
        setLoader(false);
        setDriverData(result.data);
      })
      .catch((err) => {
        setLoader(false);
        showAlert("error", err.response.data?.message ? err.response.data.message : "Something went Wrong");
        setDriverData([]);
      });
    }
    else{
      getAssignDriverList(obj)
      .then((result) => {
        setLoader(false);
        setDriverData(result.data);
      })
      .catch((err) => {
        setLoader(false);
        showAlert("error", err.response.data?.message ? err.response.data.message : "Something went Wrong");
        setDriverData([]);
      });
    }
  };

  const onChangeInput = (event) => {
    console.log(event.target.value, "valuevalue");
    setSearchedData(event.target.value);
  };

  useEffect(() => {
    console.log(
      props.Large,
      pickupType,
      props.Large && pickupType,
      "props.Large && pickupType"
    );
    if (!(props.Large && pickupType && bookingId && driverTypeField.value))
      return;
    fetchAssignDriverList();
  }, [driverTypeField.value, pickupType, bookingId, props.Large]);

  const processData = driverData
    .map((element, i) => {
      return {
        cab_number: element.carNo ? element.carNo : "-",
        driver_name: element.driverName ? element.driverName : "-",
        phone_number: element.driverMobile ? element.driverMobile : "-",
        idle_time: element.idleTime ? element.idleTime : "-",
        car_type: element.carType ? element.carType : "-",
        id: element.id,
        carId: element.carId,
        driverId: element.driverId,
        carTypeId: element.carTypeId,
        rating:
          element.megacabsRating || element.megacabsRating == 0
            ? element.megacabsRating
            : "-",
        revenue:
          element.todayRevenue || element.todayRevenue == 0
            ? element.todayRevenue
            : "-",
        distance:
          element.pickUpDistance || element.pickUpDistance == 0
            ? element.pickUpDistance
            : "-",
        // isAvailable: element?.available ? (
        //   <span className="driver-availability driver-available">Available</span>
        // ) : (
        //   <span className="driver-availability driver-blocked">Blocked</span>
        // ),
        action: (
          <Fragment>
            <div key={i} onClick={() => onDriverSelected(element)}>
              {selectedDriver?.id && selectedDriver.id == element.id ? (
                <i className="fa fa-check"></i>
              ) : (
                <i className="fa fa-user-plus"></i>
              )}
            </div>
          </Fragment>
        ),
      };
    })
    .filter((element) => {
      if (searchedData) {
        console.log("present");
        console.log(
          element.cab_number.toLowerCase().includes(searchedData.toLowerCase())
        );
        console.log(
          element.cab_number.toLowerCase(),
          searchedData.toLowerCase()
        );
        if (
          element.cab_number.toLowerCase().includes(searchedData.toLowerCase())
        ) {
          return element;
        }
      } else {
        return element;
      }
    });

  console.log("processData", processData);

  useEffect(async () => {
    if (
      !(
        props?.assignDriverBookingObj &&
        Object.keys(props.assignDriverBookingObj).length > 0
      )
    )
      return;

    let { id, pickupType, destLat, destLng, pickUpLat, pickUpLng } =
      props?.assignDriverBookingObj;

    if (!pickupType) {
      let obj = { destLat, destLng, pickUpLat, pickUpLng };
      if (destLat && destLng && pickUpLat && pickUpLng) {
        try {
          pickupType = await findPickupType(obj);
          pickupType = pickupType?.data;
        } catch (err) { }
      }
    }
    if (!pickupType) {
      showAlert("error", "Something went wrong");
      return;
    }

    reset({ driverType: "Active" });
    setPickupType(pickupType);
    setBookingId(id);
  }, [props.assignDriverBookingObj]);

  const handleDriverTypeSelect = (option) => {
    driverTypeField.onChange(option.value);
  };
  return (
    <CommonModal
      isOpen={props.Large}
      title={props.title}
      toggler={() => {
        driverTypeField.onChange("")
        props.LargeModaltoggle()
      }}
      size="xl"
    >
      <Row className="book-a-cab">
        <Row>
          <Row className="justify-content-between">
            <Col className="col-lg-4">
              <CustomSelect
                className="driver-type-select"
                classNamePrefix="driver-type-select-options"
                isClearable={false}
                isSearchable={false}
                defaultValue={DriverTypeList.find((element) => {
                  return element.value === driverTypeField?.value;
                })}
                onChange={handleDriverTypeSelect}
                placeholder="Select Driver Type"
                options={DriverTypeList}
              />
            </Col>
            <Col className="col-lg-4">
              <input
                className="form-control"
                type="text"
                {...register("searchTable", {
                  onChange: onChangeInput,
                })}
                placeholder="Search by Car Number"
                id="name"
                required
              />
            </Col>
          </Row>

          <Col className="col-12 mt-2 table-responsive assign-driver-list">
            <DataTable
              columns={driverColumns}
              data={processData}
              center={true}
              onRowClicked={onDriverSelected}
              fixedHeader
              fixedHeaderScrollHeight="51vh"
              pagination
              progressPending={loader}
              progressComponent={<div className="loader-box" style={{ height: "51vh" }}>
                <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
              </div>}
            />
          </Col>
        </Row>
        <Row className="submit-booking">
          <button
            disabled={ isSubmitting ? true : selectedDriver?.id ? false : true}
            className="btn btn-primary"
            onClick={assignDriver}
          >
            {Done}
          </button>
        </Row>
      </Row>
    </CommonModal>
  );
};

export default AssignDriver;
